import { useDispatch } from 'react-redux';
import { BtnSimple } from '../form/btn.Simple';
import { ModalGlobal } from './modal.Global';
import { setOpenModales } from '../../store/global';

export const ModalConfirm = props => {
  const { title, children, idToOpen, confirmCallback, confirmText } = props;

  const dispatch = useDispatch();

  return (
    <ModalGlobal
      title={title}
      idToOpen={idToOpen}
    >
      <div className='text-center mb-1'>{children}</div>
      <div className='flex gap-1'>
        <BtnSimple
          className='flex-1'
          onClick={() => {
            confirmCallback();
            dispatch(setOpenModales({ id: idToOpen, open: false }));
          }}
        >
          {confirmText}
        </BtnSimple>
        <BtnSimple
          className='flex-1'
          onClick={() =>
            dispatch(setOpenModales({ id: idToOpen, open: false }))
          }
        >
          Annuler
        </BtnSimple>
      </div>
    </ModalGlobal>
  );
};
